import React from 'react'
import { formTypeList } from '../../constants/form'
import BannerForm from './BannerForm'

const AddBanner = ({ setOpen }) => {
    return <BannerForm formType={formTypeList.NEW} setOpen={setOpen} />
}

export default AddBanner
